<template>
  <!-- locale 必须在根部注入：分页、日期选择、表格空态的内建文案默认是英文 -->
  <el-config-provider :locale="zhCn">
    <router-view />
  </el-config-provider>
</template>

<script setup lang="ts">
import zhCn from 'element-plus/es/locale/lang/zh-cn';
</script>
